import React from 'react'

interface IProps {
    onClick?: () => void
    placeholder: string
}

export default function LinkUnderline(props: IProps): React.ReactElement {
    return (
        <div className="link-underline" onClick={props.onClick}>
            {props.placeholder}
        </div>
    )
}
